export class EventPageController {
  constructor($scope, $rootScope, $route, $sce, toastr, EventService, UserService) {
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.sce = $sce;
    this.route = $route;
    this.toastr = toastr;
    this.EventService = EventService;
    this.UserService = UserService;
    this.init();
  }

  init() {
    this.eventId = this.route.current.params.id;
    this.eventCoverByType = this.EventService.eventCoverByType;
    this.scope.event = {};
    this.scope.isSubscribed = false;
    this.scope.isApproved = false;
    this.scope.count = {male: 0, female: 0};
    this.scope.show = {isApproved: false, error: false};
    this.scope.showTelefonoModal = false;
    this.scope.telefono = '';
    this.scope.telefonoError = '';
    this.scope.saveTelefono = () => {
      if (!this.scope.telefono) {
        this.scope.telefonoError = 'Debes ingresar tu número de teléfono';
        return;
      }
      this.scope.showTelefonoModal = false;
      this.scope.telefonoError = '';
    };

    this.scope.getEvent = () => {
      this.EventService.getEventById(this.eventId)
        .then((response) => { let event = response.data;
          this.scope.isLoadedPage = true;
          if(event.data && (event.data.status == 2 || event.data.user._id == this.rootScope.currentUserProfile._id)) {
            this.scope.show.isApproved = true;
            this.scope.show.error = false;
            this.scope.event = event.data;
            this.scope.event.details.description = this.sce.trustAsHtml(this.scope.event.details.description);
            this.scope.count = event.count;
            _.forEach(this.scope.event.registred, (id) => {
              if(id == this.rootScope.currentUserProfile._id) {
                this.scope.isSubscribed = true;
              }
            });
          } else {
            this.scope.show.isApproved = false;
            this.scope.show.error = true;
          }
        })
        .catch((response) => { let err = response.data;
          this.scope.isLoadedPage = true;
          this.scope.show.isApproved = false;
          this.scope.show.error = true;
          console.error(err);
        });
    };

    this.scope.subscribeToEvent = () => {
      if (this.rootScope.currentUserProfile.status == 0) {
        this.toastr.warning('Your profile is deactivated, you can\'t do this.');
        return;
      }

      this.EventService.subscribeToEvent(this.eventId, this.rootScope.currentUserProfile._id)
        .then((response) => { let data = response.data;
          if(data.isSubscribed === true) {
            this.toastr.info('Gracias por inscribirte al evento. ' +
              'Si por cualquier motivo no puedes asistir al evento, te ' +
              'agradeceria que nos avises haciendo clic en el menu Desinscribirse ' +
              'para ceder este cupo a otra persona.');
            this.scope.isSubscribed = true;
            this.scope.showTelefonoModal = true;
          } else if(data.isSubscribed === false) {
            this.toastr.info('Tu perfil ha sido desinscrito de este evento');
            this.scope.isSubscribed = false;
          } else {
            this.toastr.warning('No se puede suscribir');
          }
        })
        .catch((response) => { let err = response.data;
          console.error(err);
        })
    };

    this.UserService.getCurrentUser()
      .then((response) => { let user = response.data;
        this.rootScope.currentUserProfile = user.data;
        this.scope.getEvent();
      })
      .catch((response) => { let err = response.data;
        console.error(err);
      });
  }
}
